<div
  class="d-flex text-center align-items-center justify-content-center flex-column text-center p-4"
>
  <img
    src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
    alt="alert"
    width="100px"
    class="mb-3"
  />
  <h5><strong>You still have unpaid transactions</strong></h5>
  <span>Please pay your bill first, to make other transactions</span>
  <div class="col-12 mt-4 d-flex justify-content-between gap-1">
    <button class="btn btn-outline-primary col-6" (click)="cancelPayment()">
      Cancel
    </button>
    <button class="btn btn-primary text-white col-6" (click)="payNow()">
      Pay Now
    </button>
  </div>
</div>
